import { View } from '@mirai/ui';
import React from 'react';

export const Step1 = () => (
  <View data-mirai-component="rates" data-test-id={window.IS_PLAYWRIGHT ? 'rates' : undefined}>
    {/* <span data-content-error>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad itaque odio inventore eos et consequuntur molestias
      doloremque temporibus accusantium laborum rem nobis nostrum, voluptatum dolorum, repellendus quasi esse eveniet
      maxime?
    </span> */}
  </View>
);
